<template>
    <v-card class="mx-2 pb-5">
        <v-card-title class="px-5 pt-5 pb-2">
            <v-icon class="mr-3" v-if="$vuetify.breakpoint.mdAndUp">mdi-card-account-details</v-icon>
            <span class="heebo fw600">Pässe drucken</span>
            <v-spacer></v-spacer>
            <v-btn small class="mr-3" @click="exportToExcel()">
                <v-icon class="mr-1">mdi-download</v-icon>Excel Export</v-btn>
            <v-btn small color="primary" @click="refreshPaesse()">
                <v-icon class="mr-1">mdi-refresh</v-icon>Aktualisieren</v-btn>
        </v-card-title>
        <!--<paesse-drucken-vorschau-inhalt/>-->
        <v-radio-group v-if="printPaesse" v-model="printPaesse.history.show" row class="mx-5 mt-0" hide-details>
            <v-radio label="zeige Spieler die auf Pass-Druck warten" :value="false" class="mb-2"/>
            <v-radio label="zeige Druck-Historie" :value="true" class="mb-2"/>
        </v-radio-group>
        <v-row no-gutters align="center" v-if="printPaesse && printPaesse.history.show" class="mb-2">
            <v-col class="px-5">
                <input-date-optional :field="fromDate" :data-object="printPaesse.history"
                                     @dateError="setDateError" :hide-details="true"/>
            </v-col>
            <v-col class="px-5">
                <input-date-optional :field="untilDate" :data-object="printPaesse.history"
                                     @dateError="setDateError" :hide-details="true"/>
            </v-col>
        </v-row>
        <v-alert v-model="printPaesse.history.error!==''" color="error" icon="mdi-alert" text class="mx-5">{{printPaesse.history.error}}</v-alert>
        <paesse-drucken-liste/>
    </v-card>
</template>

<script>
import PaesseDruckenListe from "@/views/paesse/drucken/paesseDruckenListe";
import {PrintPaesseService} from "@/services/print/printPaesse";
import PaesseDruckenKarte from "@/views/paesse/drucken/paesseDruckenKarte";
import InputDateOptional from "@/components/form/inputDateOptional";

export default {
    name: "paesse-drucken",
    components: {InputDateOptional, PaesseDruckenKarte, PaesseDruckenListe},
    computed: {
        printPaesse(){ return this.$store.state.local.printPaesse }
    },
    created(){
        this.init()
    },
    data: () => ({
        fromDate: { excel: '', app: 'gedruckt von', childOf: '',
            type: 'date',
            cols: 6,
            notInFuture: false,
            id: 'fromDate',
        },
        untilDate: { excel: '', app: 'gedruckt bis', childOf: '',
            type: 'date',
            cols: 6,
            notInFuture: false,
            id: 'untilDate',
        },
    }),
    methods: {
        init(){
            if ( !this.printPaesse ) {
                this.$store.state.local.printPaesse = new PrintPaesseService(false)
            }
        },
        async refreshPaesse(){
            await this.printPaesse.setPendingPassList()
        },
        setDateError(e){
            this.printPaesse.history.error = !e ? '':'Ungültiges Datum'
        },
        exportToExcel(){
            this.printPaesse.exportToExcel()
        }
    },
    watch: {
        'printPaesse.history.show'(from){
            if ( from !== undefined ) this.refreshPaesse()
        }
    }
}
</script>

<style scoped>

</style>